'use strict';

module.exports = require('./components/DisqusThread');


//////////////////
// WEBPACK FOOTER
// ./~/react-disqus-comments/build/main.js
// module id = 156
// module chunks = 214931554640647 224430643053503